/**
 * Single source of truth for the project schema version.
 *
 * Increment rule: ANY change to the project file's schema increments
 * PROJECT_FORMAT_VERSION: a field added, removed, retyped, or given new meaning. There is no
 * major/minor judgement call and no second counter to keep in step.
 *
 * History of this value:
 *   1  original
 *   2  font_width_factor added to TextStyle          (PME-889)
 *   3  line_spacing written by the editor            (PME-890)
 *
 * Both of those shipped without a bump, which is what CMME-10 is about: project.json was left
 * saying 1 while version.json independently said 2.
 *
 * This value is written into `project.json > project > format_version` and is the value
 * `version.json`'s component entry for project.json is derived FROM (see getVersionControl.ts).
 * Do not restate it anywhere else.
 *
 * NOT to be confused with `version.json > package_format_version`, which versions the .cmme
 * package structure and is an unrelated field that happens to also hold 3 today.
 */
export var PROJECT_FORMAT_VERSION = 3;
/**
 * Revision counter emitted alongside the format version in `version.json`.
 *
 * This is NOT a schema signal for project.json: project schema changes move
 * PROJECT_FORMAT_VERSION, never this. PME-890 briefly moved this field instead (1 -> 2) for the
 * line_spacing addition; that increment now lives in PROJECT_FORMAT_VERSION, so counting it here
 * as well would count the same change twice. Reset to 1 and expected to stay there.
 */
export var PROJECT_DATA_REVISION = 1;
